const basePath = '/personal/my-results'

export const ROUTER_PERSONAL_MY_RESULT = {
	root: `${basePath}`,
	result_detail: id => (id ? `${basePath}/${id}` : `${basePath}/:id`)
}
